<!--
 * @Author: your name
 * @Date: 2020-09-29 13:14:43
 * @LastEditTime: 2021-03-23 14:54:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\views\Login.vue
-->
<template>
  <div id="login">
    <template v-if="isShowLogin==1">
      <el-row class="title">
        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
          <img src="../assets/img/shanghai-new.png" alt="">
        </el-col>
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
          <img src="../assets/img/主页 (1).png" alt="">
          <el-link class="help" href="http://www.shanghaicredit.org/" :underline="false" target="_blank">官网首页</el-link>
        </el-col>
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
          <img src="../assets/img/adoutxh-top.png" alt="">
          <el-link class="help" href="http://www.shanghaicredit.org/about.php" :underline="false" target="_blank">关于协会</el-link>
        </el-col>
      </el-row>
      <el-row class="content">
        <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="content_left">
          <br>
          <ul class="circle">
            <li class="common" v-for="(item,index) in circleData" :key="index" @mouseenter="handleEnter(index)" @mouseleave="handleLeave(index)">
              <template v-if="activeIndex==index">
                <img ref="imageRef" class=" hexagon" src="../assets/img/六边形高亮.png" alt="">
                <img class="hexagon_icon" :src="item.img1" alt="">
                <span class="detail">{{item.con}}</span>
              </template>
              <template v-else>
                <img src="../assets/img/六边形.png" alt="">
                <img class="hexagon_icon" :src="item.img11" alt="">
                <span>{{item.con}}</span>
              </template>
            </li>
            <li class="information">
              <h4>{{circleData[activeIndex].con}}</h4>
              <div class="dot1"></div>
              <div class="dot2"></div>
              <div class="dot3"></div>
              <p>{{circleData[activeIndex].tips}}</p>
              <!-- <button class="more" v-if="circleData[activeIndex].con=='查看最新政策信息'">更多<i class="el-icon-arrow-right"></i></button> -->
              <div class="dot4"></div>
              <div class="dot5"></div>
              <div class="dot6"></div>
              <div class="dot7">敬请期待</div>
            </li>
          </ul>
          <img src="../assets/img/服 务.png" alt="" class="icon1">
          <img src="../assets/img/组 12.png" alt="" class="icon2">
          <img src="../assets/img/管理.png" alt="" class="icon3">
          <img src="../assets/img/管理平台.png" alt="" class="icon4">
          <img src="../assets/img/组 11.png" alt="" class="icon5">
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-row class="content_form">
            <div class="corner corner1"></div>
            <div class="corner corner2"></div>
            <div class="corner corner3"></div>
            <div class="corner corner4"></div>
            <p class="description">欢迎登录上海信用服务行业综合智慧数据库管理平台</p>
            <el-form :model="loginRuleForm" :rules="loginRules" ref="loginRuleForm" label-width="0px" class="demo-ruleForm loginContentForm">
              <el-form-item prop="email" class="email">
                <el-input v-model="loginRuleForm.email" placeholder="邮箱">
                  <i slot="prepend" class="el-icon-message" />
                </el-input>
              </el-form-item>
              <el-form-item prop="password" class="password">
                <el-input type="password" placeholder="密码" v-model="loginRuleForm.password" @keyup.enter.native="loginVerifyAccount()">
                  <i slot="prepend" class="el-icon-lock" />
                </el-input>
              </el-form-item>
              <div class="forgetPwd">
                <el-link :underline="false" target="_blank" @click="forgetPwd">忘记密码?</el-link>
              </div>
              <el-form-item>
                <el-button @click="loginVerifyAccount()" class="submit">登 录</el-button>
              </el-form-item>
              <div class="application">
                <el-link :underline="false" @click="applyMenmber">申请加入协会</el-link>
              </div>
            </el-form>
          </el-row>
        </el-col>
      </el-row>
    </template>
    <template v-else-if="isShowLogin==2">
      <!-- 通过绑定邮箱更改密码 -->
      <el-dialog title="通过绑定邮箱更改密码" :visible.sync="editPassVisible" width="32%" custom-class="editInfoVisible editPassVisible" @close="closeeditInfoDialog" :close-on-click-modal="false">
        <el-steps :active="stepActive" v-if="stepActive==0 ||stepActive==1" space="200px" :align-center="true">
          <el-step title="验证账号"></el-step>
          <el-step title="变更信息"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
        <el-divider v-if="stepActive==0 ||stepActive==1"></el-divider>
        <el-form :model="editInfoForm" status-icon :rules="editInfoRules" ref="editInfoPasForm" label-width="160px" class="editInfoForm" v-if="stepActive==0">
          <el-form-item label="邮箱" prop="email">
            <el-input placeholder="请输入邮箱" v-model="editInfoForm.email" autocomplete="new-password"></el-input>
            <el-button :disabled="isDisable" @click="checkEmail" class="button common getCode">{{isDisable?`${time}s`:'获取验证码'}}</el-button>
          </el-form-item>
          <el-form-item label="验证码" prop="captcha" class="code">
            <el-input type="password" placeholder="请输入验证码" v-model="editInfoForm.captcha" autocomplete="new-password"></el-input>
          </el-form-item>
        </el-form>
        <el-form :model="newPasswordForm" status-icon :rules="newPasswordRules" ref="newPasswordForm" label-width="220px" class="editInfoForm newEmailForm" v-show="stepActive==1">
          <el-form-item label="用户当前账号">
            <p>{{newPasswordForm.email}}</p>
          </el-form-item>
          <el-form-item label="新密码" prop="password" class="code">
            <el-input type="password" placeholder="请输入新密码" v-model="newPasswordForm.password"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="newPassword" class="code">
            <el-input type="password" placeholder="请确认新密码" v-model="newPasswordForm.newPassword"></el-input>
          </el-form-item>
        </el-form>
        <el-row v-show="stepActive==2" style="text-align:center;">
          <img src="@/assets/img/修改成功.png" alt="">
          <p>密码修改成功!</p>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <template v-if="stepActive==0">
            <el-button @click="next(editInfoForm)" class="button add common">下一步</el-button>
            <el-button @click="isShowLogin=1" class="button common">返回登录页</el-button>
          </template>
          <template v-if="stepActive==1">
            <el-button type="primary" @click="stepActive=0" class="button add common">上一步</el-button>
            <el-button type="primary" @click="nextStep" class="button add common">确定</el-button>
          </template>
          <el-button v-if="stepActive==2" @click="editSuccess" class="button   common sure">确定</el-button>
        </span>
      </el-dialog>
    </template>

    <div class="login-beian">
      <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备17014711号-2</a>
      <img src="../assets/img/hgwab.png" alt="">
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011002005601" target="_blank">沪公网安备 31011002005601号</a>
    </div>
    <!-- 请选择身份进入 -->
    <el-dialog :modal='false' title="登录" :close-on-click-modal='false' :close-on-press-escape='false' :visible.sync="centerDialogVisible" width="40%" class="roleLogin-dialog">
      <div>
        <p class="choose-role-title">请选择身份进入</p>
        <ul class="choose-role-card">
          <li @click="roleLogin(1)">
            <img src="@/assets/img/roleAdmin.png" alt="">
            <p>系统管理员</p>
          </li>
          <li @click="roleLogin(2)">
            <img src="@/assets/img/roleManage.png" alt="">
            <p>协会工作人员</p>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { isvalidPass, emailTest } from '@/assets/js/common'
import { editEmail, getCaptcha, sendCaptcha, login, checkEmail } from '@/api/index'
export default {
  data() {
    var validatePass1 = (rule, value, callback) => {
      if (value === '' || value == undefined) {
        callback(new Error('请输入密码'));
      } else if (!isvalidPass(value)) {
        callback(new Error('密码长度在6~18之间 包含字母和数字'))
      }
      else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.newPasswordForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入邮箱'));
      } else if (!emailTest(value)) {
        callback(new Error('请输入合法的邮箱!'));
      } else {
        callback();
      }
    };
    return {
      isShowLogin: 1,
      circleData: [
        // {
        //   img1: require('../assets/img/服务失信行业.png'),
        //   img11: require('../assets/img/服务失信行业1.png'),
        //   con: '精准服务失信企业',
        //   tips: '通过开发信用修复课程和教材，有效开展信用修复与培训管理体系流程的建设，重点针对失信企业开展在线辅导，使其在今后的企业经营过程不再失信，最终提升企业经营管理能力，为社会治理服务。',
        //   status: false
        // },
        {
          img1: require('../assets/img/服务信用人才.png'),
          img11: require('../assets/img/服务信用人才1.png'),
          con: '精准服务信用人才',
          tips: '通过综合智慧系发布信用人才需求信息、提供信用人才供给信息、精准选择适合供求双方意愿的人才，实现信用管理人才高效交流，通过平台＋基地为信用人才发展赋能，体现信用人才价值最大化。',
          status: false
        },
        {
          img1: require('../assets/img/红黑榜.png'),
          img11: require('../assets/img/红黑榜1.png'),
          con: '信用红黑榜公示',
          tips: '通过建立企业诚信档案，完善信用一体化平台，并推动建立协同监管平台，加快实现企业信用信息有效归集与公示，完善经营异常名录、严重违法失信企业名单制度。',
          status: false
        },
        {
          img1: require('../assets/img/政策.png'),
          img11: require('../assets/img/政策1.png'),
          con: '查看最新政策信息',
          tips: '项目信息、监管信息、信用指数研究成果、政策解读、行业新闻动态历史活动信息、专家信息',
          status: false
        },
        {
          img1: require('../assets/img/营商环境.png'),
          img11: require('../assets/img/营商环境1.png'),
          con: '精准服务营商环境',
          tips: '通过综合智慧平台逐步发布上海信用指数、信用行业指数、长三角区域信用指数、信用行业发展标准、信用行业统计报告、信用行业发展报告等来引导营商环境的改善。'
        },
        {
          img1: require('../assets/img/实体经济.png'),
          img11: require('../assets/img/实体经济1.png'),
          con: '精准服务实体经济',
          tips: '发布信用服务机构的产品和服务信息，有需求的企业和机构可在平台上找到合适的机构，为产业链上下游企业及各市场需求主体服务，为上海企业走出去投资建设一带一路提供信用风险管理服务。',
          status: false
        },

      ],
      activeIndex: 0,
      loginRuleForm: {
        email: '',
        password: ''
      },
      loginRules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          // { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      timer: null,
      editPassVisible: false,
      stepActive: 0,
      editInfoForm: {
        email: '',
        captcha: ''
      },
      editInfoRules: {
        email: [{ required: true, validator: validateEmail, trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      isDisable: false,
      timer: null,
      time: 60,
      newPasswordForm: {
        email: "",
        password: '',
        newPassword: '',
        captcha: ''
      },
      newPasswordRules: {
        password: [{ required: true, validator: validatePass1, trigger: 'blur' }],
        newPassword: [{ required: true, validator: validatePass2, trigger: 'blur' }],
      },
      centerDialogVisible: false,
    };
  },
  created() {
    console.log(process.env.NODE_ENV);
    this.init()
  },
  destroyed() {
    clearInterval(this.timer ? this.timer : '')
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        this.activeIndex += 1
        if (this.activeIndex === 6) {
          this.activeIndex = 0
        }
      }, 4000);
    },
    handleEnter(index) {
      this.circleData[index].imgUrl = require('../assets/img/六边形高亮.png')
      this.circleData[index].status = true
      this.num = index
    },
    handleLeave(index) {
      this.circleData[index].imgUrl = require('../assets/img/六边形.png')
      this.circleData[index].status = false
    },
    // 申请加入会员
    applyMenmber() {

      this.$router.push({
        path: '/ApplyMembership'
      })
    },
    // 点击登录的时候判断是否是某账号
    loginVerifyAccount() {
      this.$refs.loginRuleForm.validate((valid) => {
        if (valid) {
          if (this.loginRuleForm.email == 'wwj1301@126.com' || this.loginRuleForm.email == 'wwj13012021@163.com') {
            this.centerDialogVisible = true;
          } else {
            this.submitForm()
          }
        }
      })

    },
    // 请选择身份进入
    roleLogin(roleType) {
      // data.roleType 1-admin 2-协会工作人员（管理员）
      if (roleType == 1) {
        this.loginRuleForm.email = 'wwj1301@126.com'
        this.loginRuleForm.password = 'aaa111'

      } else if (roleType == 2) {
        this.loginRuleForm.email = 'wwj13012021@163.com'
        this.loginRuleForm.password = 'abc123'
      }
      this.submitForm()
    },
    // 点击登录
    async submitForm() {
      try {
        const { data } = await login(this.loginRuleForm)
        if (data.code == 0) {
          sessionStorage.setItem('token', data.token)
          sessionStorage.setItem('email', this.loginRuleForm.email)
          sessionStorage.setItem('password', this.loginRuleForm.password)
          sessionStorage.setItem('userPermissionType', data.userPermissionType)
          this.$store.commit('saveRoleType', data.roleType)
          this.$store.commit('saveUserId', data.userId)
          // data.roleType 1-admin 2-协会工作人员（管理员） 3-会员
          if (data.roleType == 3) {
            this.$router.push('/home')
            setTimeout(() => {
              this.$parent.$children[0].remindVisible = true
            }, 100);

          } else {
            this.$router.push('/home')
          }
        }
      } catch (error) {
        // console.log(error);
        this.$message.error(error.data.msg);
      }


    },
    // 忘记密码
    forgetPwd() {
      this.stepActive = 0
      this.isShowLogin = 2
      this.editPassVisible = true
      this.editInfoForm = {
        email: '',
        captcha: ''
      }
      this.time = 60
      this.isDisable = false
    },
    closeeditInfoDialog() {
      this.isShowLogin = 1
      this.$refs.editInfoPasForm.resetFields()
    },
    async checkEmail() {
      try {
        const { data } = await checkEmail(this.editInfoForm.email)
        if (data.check == true) {
          this.sendCode()
        } else {
          this.$message.error('该邮箱不存在')
        }
      } catch (error) {
        // console.log(error);
      }

    },
    async sendCode() {
      try {
        clearInterval(this.timer)
        const { data } = await sendCaptcha(this.editInfoForm.email)
        if (data.code == 0) {
          this.isDisable = true
          this.timer = setInterval(() => {
            if (this.time < 1) {
              clearInterval(this.timer)
              this.isDisable = false
              this.time = 60
            } else {
              this.time -= 1
            }
          }, 1000);
        } else {
          this.$message.error(data.msg)
        }
      } catch (error) {
        // console.log(error);
      }

    },
    next(form) {
      this.$refs.editInfoPasForm.validate(async (valid) => {
        if (valid) {
          try {
            this.newPasswordForm.email = form.email
            this.newPasswordForm.captcha = form.captcha
            let passTe = {}
            passTe.email = form.email
            passTe.captcha = form.captcha

            const { data } = await getCaptcha(passTe)
            if (data.code == 0) {

              this.stepActive = 1
            } else {
              this.$message.error(data.msg)
            }
            clearInterval(this.timer)

          } catch (error) {
            this.$message.error(error.data.msg)
          }

        }
      })

    },
    nextStep() {
      this.$refs.newPasswordForm.validate(async (valid) => {
        if (valid) {
          const { data } = await editEmail(this.newPasswordForm)
          if (data.code !== 0) return
          this.stepActive = 2
        }
      })
    },
    editSuccess() {
      this.editInfoVisible = false
      this.isShowLogin = 1
    },
  },
  components: {},
};
</script>
<style lang="less" scoped>
@keyframes fadeIn {
  0% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.6;
  }
  75% {
    opacity: 0.8;
  }
  100% {
    opacity: 1;
  }
}
#login {
  width: 100%;
  height: 100%;
  background: url(~@/assets/img/bg.png) no-repeat center fixed;
  -webkit-background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  -o-background-size: 100% 100%;
  background-size: 100% 100%;
  .title {
    padding: 20px;
    .help {
      color: #fff;
      display: inline-block;
      padding-left: 10px;
      cursor: pointer;
      font-size: 16px;
    }
    img {
      vertical-align: middle;
    }
  }
  .content {
    margin-top: 150px;
    position: relative;
    .content_left {
      .circle {
        position: absolute;
        width: 587px;
        height: 580px;
        top: 0;
        left: 20%;
        transform: translate(0, -10%);
        background: url("../assets/img/圆环.png") no-repeat;
        .common {
          width: 165px;
          height: 145px;
          color: #ccc;
          position: absolute;
          font-size: 13px;
          text-align: center;
          line-height: 20px;
          .hexagon {
            position: absolute;
            top: -20px;
            left: -20px;
            animation: fadeIn 3s linear;
          }
          .hexagon_icon {
            position: absolute;
            top: 10%;
            left: 50%;
            transform: translate(-50%, 0);
          }
          span {
            display: inline-block;
            position: absolute;
            bottom: 13%;
            left: 50%;
            transform: translate(-50%, 0);
          }
          .detail {
            color: #fff;
          }
        }
        li:nth-child(1) {
          top: 0;
          left: 50%;
          transform: translate(-50%, 0);
        }
        li:nth-child(2) {
          top: 28%;
          right: 0;
        }
        li:nth-child(3) {
          top: 70%;
          right: 10%;
        }
        li:nth-child(4) {
          top: 70%;
          left: 10%;
          // transform: translate(-50%, 0);
        }
        li:nth-child(5) {
          top: 28%;
          left: 0;
        }
        // li:nth-child(6) {
        //   bottom: 55%;
        //   left: 0;
        // }
        .information {
          position: absolute;
          width: 387px;
          height: 387px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
          // animation: fadeIn 3s linear;
          h4 {
            color: #01e6ff;
            font-size: 16px;
            margin-top: 70px;
          }
          .dot1 {
            position: absolute;
            left: 30%;
            top: 28%;
            width: 70px;
            height: 1px;
            background-color: #01e6ff;
          }
          .dot2 {
            position: absolute;
            left: 50%;
            top: 28%;
            transform: translate(-50%, 0);
            width: 3px;
            height: 3px;
            background-color: #01e6ff;
            border-radius: 50%;
          }
          .dot3 {
            position: absolute;
            right: 30%;
            top: 28%;
            width: 70px;
            height: 1px;
            background-color: #01e6ff;
          }
          .dot4 {
            position: absolute;
            left: 30%;
            top: 77%;
            width: 70px;
            height: 1px;
            background-color: #01e6ff;
          }
          .dot5 {
            position: absolute;
            left: 50%;
            top: 77%;
            transform: translate(-50%, 0);
            width: 3px;
            height: 3px;
            background-color: #01e6ff;
            border-radius: 50%;
          }
          .dot6 {
            position: absolute;
            right: 30%;
            top: 77%;
            width: 70px;
            height: 1px;
            background-color: #01e6ff;
          }
          .dot7 {
            position: absolute;
            right: 50%;
            top: 80%;
            width: 70px;
            color: #ccc;
            font-size: 15px;
            transform: translateX(50%);
          }
          p {
            padding: 45px 70px;
            color: #ccc;
            line-height: 1.7;
            font-size: 15px;
            text-align: left;
          }
          button {
            width: 80px;
            height: 30px;
            border-radius: 15px;
            border: solid 1px #01e6ff;
            color: #01e6ff;
            background: rgba(0, 0, 0, 0);
            cursor: pointer;
          }
        }
      }
      .icon1 {
        position: absolute;
        top: 8%;
        left: 10%;
      }
      .icon2 {
        position: absolute;
        top: 45%;
        left: 12%;
      }
      .icon3 {
        position: absolute;
        bottom: -5%;
        left: 18%;
      }
      .icon4 {
        position: absolute;
        top: 13%;
        left: 55%;
      }
      .icon5 {
        position: absolute;
        bottom: 15%;
        left: 55%;
      }
    }
    .content_form {
      position: relative;
      width: 412px;
      height: 444px;
      border: 1px solid rgba(0, 230, 255, 0.28);
      padding: 40px;
      .corner {
        position: absolute;
        width: 24px;
        height: 24px;
      }
      .corner1 {
        top: 0;
        left: 0;
        border-top: 4px solid #00e6ff;
        border-left: 4px solid #00e6ff;
      }
      .corner2 {
        top: 0;
        right: 0;
        border-top: 4px solid #00e6ff;
        border-right: 4px solid #00e6ff;
      }
      .corner3 {
        bottom: 0;
        left: 0;
        border-bottom: 4px solid #00e6ff;
        border-left: 4px solid #00e6ff;
      }
      .corner4 {
        bottom: 0;
        right: 0;
        border-bottom: 4px solid #00e6ff;
        border-right: 4px solid #00e6ff;
      }
      .description {
        font-size: 18px;
        color: #ffffff;
        line-height: 30px;
        // > span {
        //   font-size: 24px;
        // }
      }
      .loginContentForm {
        margin-top: 30px;
        .email,
        .password {
          background-color: #ffffff;
          border-radius: 4px;
          border: solid 1px #086ecd;
          font-size: 18px;
          color: #0162e7;
        }
        .forgetPwd {
          text-align: right;
          margin-bottom: 20px;
          .el-link {
            color: #09e4fd;
            border-bottom: 1px solid #09e4fd;
          }
        }
        .submit {
          width: 100%;
          background-color: #0162e7;
          border-radius: 4px;
          color: #fff;
          border: solid 1px #086ecd;
        }
        .application {
          text-align: center;
          .el-link {
            color: #fff;
            border-bottom: 1px solid #fff;
          }
        }
      }
    }
  }
  /deep/.editPassVisible {
    .common {
      line-height: 0;
      width: 110px;
      display: inline-block;
      // margin-right: 20px;
    }
    .getCode {
      width: 125px;
      background-color: #286ac4;
      color: #fff;
    }
    .sure {
      background-color: #286ac4;
      color: #fff;
    }
    .el-input {
      width: 65% !important;
      .el-input__inner {
        width: 95%;
      }
      .el-input__suffix {
        right: 20px;
      }
    }
  }
  .remindVisible {
    z-index: 9999;
  }
  .login-beian {
    width: 100%;
    text-align: center;
    color: #fff;
    position: fixed;
    bottom: 5%;
    left: 0;
    a {
      color: #fff;
      text-decoration: none;
    }
    img {
      vertical-align: text-bottom;
      margin: 0 5px 0 10px;
    }
  }
  // 选择身份
  .roleLogin-dialog {
    /deep/.el-dialog__header {
      text-align: left;
      margin: 0;
      padding: 12px 20px 10px;
      .el-dialog__title {
        font-size: 16px;
        color: #333;
      }
    }
    .choose-role-title {
      text-align: center;
      font-size: 14px;
      letter-spacing: 0px;
      color: #333333;
    }
    .choose-role-card {
      padding: 30px 10% 10%;
      display: flex;
      justify-content: space-between;
      li {
        width: 36%;
        border-radius: 15px;
        border: solid 1px #f4f5f6;
        cursor: pointer;
        text-align: center;
        padding: 20px 26px;
        color: #999999;
        img {
          width: 100%;
        }
        p {
          font-size: 18px;
          margin: 16% 0 18%;
        }
      }
      li:hover {
        border: solid 1px #adcdf7;
        box-shadow: 0 0 8px #adcdf7;
        color: #333333;
      }
    }
  }
}
</style>
